import { useQuery } from 'react-query';
import axios from '../utils/axios-util';

const getEditVisualisationById = (customer, id) => {
  return axios({
    url: `/config/${customer}/visualisation/${id}`,
    method: 'get'
  });
};
const useGetEditVisualisationById = (customer, id) => {
  return useQuery(['get', 'formData', id], () => getEditVisualisationById(customer, id), {
    enabled: !!customer && !!id
  });
};

export default useGetEditVisualisationById;
